import Images from '../themes/categoryImages';
import {
  icAnyThing,
  icAnyThingActive,
  icCasualEncounter,
  icCasualEncounterActive,
  icCocktailBar,
  icCocktailBarActive,
  icCoffee,
  icCoffeeActive,
  icConcert,
  icConcertActive,
  icCouple,
  icCoupleActive,
  icCoupleDarkMode,
  icCoupleFF,
  icCoupleFFActive,
  icCoupleFFDarkMode,
  icCoupleMM,
  icCoupleMMActive,
  icCoupleMMDarkMode,
  icDinner,
  icDinnerActive,
  icFetishParty,
  icFetishPartyActive,
  icGroup,
  icGroupActive,
  icGroupDarkMode,
  icHouseParty,
  icHousePartyActive,
  icMen,
  icMenActive,
  icMenDarkMode,
  icMyBedroom,
  icMyBedroomActive,
  icMyPlace,
  icMyPlaceActive,
  icPubCrawl,
  icPubCrawlActive,
  icSpaHotTub,
  icSpaHotTubActive,
  icSportingEvent,
  icSportingEventActive,
  icSwingersParty,
  icSwingersPartyActive,
  icTransMan,
  icTransManActive,
  icTransManDarkMode,
  icTransWoman,
  icTransWomanActive,
  icTransWomanDarkMode,
  icTVCD,
  icTVCDActive,
  icTVCDDarkMode,
  icWoman,
  icWomanActive,
  icWomanDarkMode,
} from '../themes/ImagesSVG';
import { SCREENS_NAME } from './constants';

export const UPDATE_INFO_SCREEN = [
  'LOOKING_TO_MEET',
  'TELL_US_ABOUT_YOURSELF_1',
  'TELL_US_ABOUT_YOURSELF_2',
  'TELL_US_ABOUT_YOURSELF_3',
  'TELL_US_ABOUT_YOURSELF_4',
];

export const ROW_NUMBER_CATEGORY = {
  GENERAL_AND_FETISH_SEXUAL: 5,
};

export const REGISTER_SCREEN = {
  LOOKING_TO_MEET: 0,
  TELL_US_ABOUT_YOURSELF_1: 1,
  TELL_US_ABOUT_YOURSELF_2: 2,
  WHAT_ARE_YOUR_INTERESTS: 3,
  TELL_US_ABOUT_YOURSELF_4: 4,
};

export const MODAL_PROFILE_BUILDER_TYPE = {
  INTRODUCE: 'INTRODUCE',
  LOOKING_FOR: 'LOOKING_FOR',
};

export const CATEGORY_ID = {
  LOCATION: 'location',
  // Looking To Meet
  // LTM_LOOKING_FOR: "LTM_LOOKING_FOR",
  LTM_LOOKING_FOR: 'lookingFor',
  // LTM_AGE_RANGE: "LTM_AGE_RANGE",
  LTM_AGE_RANGE: 'ageRange',
  // LTM_INTENTIONS: "LTM_INTENTIONS",
  LTM_INTENTIONS: 'intentions',
  LTM_DEAL_BREAKER: 'dealBreaker',

  // Tell us about yourself 1
  TU1_SEX: 'sex',
  // TU1_SEX: "TU1_SEX",
  TU1_AGE: 'age',
  TU1_ETHNICITY: 'ethnicity',
  RELATION_SHIP: 'relationship',

  // Tell us about yourself 2
  TU2_BODY_TYPE: 'bodyTypes',
  TU2_HEIGHT: 'height',
  TU2_ORIENTATION: 'orientation',

  // Tell us about yourself 3
  WYI_GENERAL: 'general',
  WYI_SEXUAL: 'sexual',
  WYI_SEXUAL_SIGNLE: 'sexualsignle',
  WYI_SEXUAL_COUPLE: 'sexualcouple',
  WYI_FETISH: 'fetish',

  // Introduce yourself
  IY_ABOUT_YOU: 'aboutYou',
  IY_YOUR_IDEAL_MATCH: 'yourIdealMatch',

  // Modal profile builder
  MPB_PERSONALITY: 'personality',
  MPB_LOOKS: 'looks',
  MPB_INTERESTS: 'interests',
  MPB_LOOKINGFOR: 'mpbLookingFors',
  SAFE_SEX: 'safeSex',
  PARTICIPATION_LEVEL: 'participationLevel',
  ENDOWMENT: 'endowment',
  MARITAL_STATUS: 'maritalStatus',
  // Modal Refine search
  MS_LOOKING_FOR: 'lookingFor',
  MS_SHOW_ME_MEMBER_TYPE: 'showMeMemberType',
  SEXUAL_INTERESTS: 'sexualInterests',
  INTRO_BODY: 'introbody',
  EVENT_CATEGORY: 'eventCategory',
  MEETING_TYPE: 'meetingTypes',
  SMOKING: 'smoking',
  CUP_SIZE: 'cupSize',
  PUBIC_HAIR: 'pubicHair',
  MS_MEMBER_TYPE: 'memberType',
};

export type CategoryIdType = (typeof CATEGORY_ID)[keyof typeof CATEGORY_ID];

export const CATEGORY_NUMBER = {
  [CATEGORY_ID.LTM_LOOKING_FOR]: 0,
  [CATEGORY_ID.LTM_AGE_RANGE]: 1,
  [CATEGORY_ID.LTM_INTENTIONS]: 2,
  [CATEGORY_ID.TU1_SEX]: 3,
  [CATEGORY_ID.TU1_AGE]: 4,
  [CATEGORY_ID.TU1_ETHNICITY]: 5,
  [CATEGORY_ID.TU2_BODY_TYPE]: 6,
  [CATEGORY_ID.TU2_HEIGHT]: 7,
  [CATEGORY_ID.TU2_ORIENTATION]: 8,
  [CATEGORY_ID.WYI_GENERAL]: 9,
  [CATEGORY_ID.WYI_SEXUAL]: 10,
  [CATEGORY_ID.WYI_FETISH]: 11,
  [CATEGORY_ID.IY_ABOUT_YOU]: 12,
  [CATEGORY_ID.IY_YOUR_IDEAL_MATCH]: 13,
  [CATEGORY_ID.MPB_PERSONALITY]: 14,
  [CATEGORY_ID.MPB_LOOKS]: 15,
  [CATEGORY_ID.MPB_INTERESTS]: 16,
  [CATEGORY_ID.MPB_LOOKINGFOR]: 17,
};

export const LAST_CATEGORY_SCREEN = {
  [SCREENS_NAME.LOOKING_TO_MEET]: CATEGORY_ID.LTM_LOOKING_FOR,
  [SCREENS_NAME.TELL_US_ABOUT_YOURSELF_1]: CATEGORY_ID.TU1_SEX,
  [SCREENS_NAME.TELL_US_ABOUT_YOURSELF_2]: CATEGORY_ID.TU2_BODY_TYPE,
  [SCREENS_NAME.WHAT_ARE_YOUR_INTERESTS]: CATEGORY_ID.WYI_GENERAL,
  [SCREENS_NAME.INTRODUCE_YOURSELF]: CATEGORY_ID.IY_ABOUT_YOU,
};

export const UPDATE_INFO_STEP = [
  CATEGORY_ID.LTM_LOOKING_FOR,
  CATEGORY_ID.LTM_AGE_RANGE,
  CATEGORY_ID.LTM_INTENTIONS,
  CATEGORY_ID.TU1_SEX,
  CATEGORY_ID.TU1_AGE,
  CATEGORY_ID.TU1_ETHNICITY,
  CATEGORY_ID.TU2_BODY_TYPE,
  CATEGORY_ID.TU2_HEIGHT,
  CATEGORY_ID.TU2_ORIENTATION,
  CATEGORY_ID.WYI_GENERAL,
  CATEGORY_ID.WYI_SEXUAL,
  CATEGORY_ID.WYI_FETISH,
  CATEGORY_ID.IY_ABOUT_YOU,
  CATEGORY_ID.IY_YOUR_IDEAL_MATCH,
];

export const STEP_ID = {
  STEP_1: 0,
  STEP_2: 1,
  STEP_3: 2,
  STEP_4: 3,
  STEP_5: 4,
  STEP_6: 5,
  STEP_7: 6,
  STEP_8: 7,
  STEP_9: 8,
};

export const SEX_TYPE = {
  MEN: '1',
  WOMEN: '2',
  COUPLES: '4',
  GROUPS: '8',
  COUPLES_FF: '16',
  COUPLES_MM: '32',
  TV_CD: '64',
  TRANS_WOMAN: '128',
  TRANS_MAN: '256',
};

export const BODY_TYPE = {
  THIN: '1',
  SLIM: '2',
  ATHLETIC: '3',
  AVERAGE: '4',
  CUDDLY: '6',
  // A_LITTLE_PADDING: "6",
  LARGE: '7',
};

export const MEETING_TYPE = {
  ANY_THING: '1',
  CASUAL_ENCOUNTER: '2',
  HANG_OUT: '4',
  HOUSE_PARTY: '8',
  CONCERT: '16',
  DINNER: '32',
  PUB_CRAWL: '64',
  COCKTAIL_BAR: '128',
  SPORTING_EVENT: '256',
  COFFEE: '512',
  MY_PLACE: '1024',
  MY_BEDROOM: '2048',
  FETISH_PARTY: '4096',
  SWINGERS_PARTY: '8192',
  SPA_HOT_TUB: '16384',
};

export const CATEGORY_LOOKING_FOR_ITEM_LABEL = {
  [SEX_TYPE.MEN]: 'Men',
  [SEX_TYPE.WOMEN]: 'Women',
  [SEX_TYPE.COUPLES]: 'Couples',
  [SEX_TYPE.GROUPS]: 'Groups',
  [SEX_TYPE.COUPLES_FF]: 'Couples FF',
  [SEX_TYPE.COUPLES_MM]: 'Couples MM',
  [SEX_TYPE.TV_CD]: 'TV/CD',
  [SEX_TYPE.TRANS_WOMAN]: 'Trans Woman',
  [SEX_TYPE.TRANS_MAN]: 'Trans Man',
};

export const CATEGORY_ITEM_ICON = {
  [CATEGORY_ID.LTM_LOOKING_FOR]: {
    [SEX_TYPE.MEN]: Images.icWhoMen,
    [SEX_TYPE.WOMEN]: Images.icWhoWoman,
    [SEX_TYPE.COUPLES]: Images.icWhoCouple,
    [SEX_TYPE.GROUPS]: Images.icWhoGroup,
    [SEX_TYPE.COUPLES_FF]: Images.icWhoCoupleFF,
    [SEX_TYPE.COUPLES_MM]: Images.icWhoCoupleMM,
    [SEX_TYPE.TV_CD]: Images.icWhoTVCD,
    [SEX_TYPE.TRANS_WOMAN]: Images.icWhoTransWoman,
    [SEX_TYPE.TRANS_MAN]: Images.icWhoTransMan,
  },

  [CATEGORY_ID.TU2_BODY_TYPE]: {
    [BODY_TYPE.THIN]: Images.icBodyTypeThin,
    [BODY_TYPE.SLIM]: Images.icBodyTypeSlim,
    [BODY_TYPE.ATHLETIC]: Images.icBodyTypeAthletic,
    [BODY_TYPE.AVERAGE]: Images.icBodyTypeAverage,
    [BODY_TYPE.CUDDLY]: Images.icBodyTypeCuddly,
    // [BODY_TYPE.A_LITTLE_PADDING]: '',//TODO: no image
    [BODY_TYPE.LARGE]: Images.icBodyTypeLarge,
  },

  [CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE]: {
    [SEX_TYPE.MEN]: {
      active: icMenActive,
      noActive: icMen,
      activePng: 'icMenActive',
      noActivePng: 'icMen',
      noActiveDarkMode: icMenDarkMode,
    },
    [SEX_TYPE.WOMEN]: {
      active: icWomanActive,
      noActive: icWoman,
      noActiveDarkMode: icWomanDarkMode,
      activePng: 'icWomanActive',
      noActivePng: 'icWoman',
    },
    [SEX_TYPE.COUPLES]: {
      active: icCoupleActive,
      noActive: icCouple,
      noActiveDarkMode: icCoupleDarkMode,
      activePng: 'icCoupleActive',
      noActivePng: 'icCouple',
    },
    [SEX_TYPE.GROUPS]: {
      active: icGroupActive,
      noActive: icGroup,
      noActiveDarkMode: icGroupDarkMode,
      activePng: 'icGroupActive',
      noActivePng: 'icGroup',
    },
    [SEX_TYPE.COUPLES_FF]: {
      active: icCoupleFFActive,
      noActive: icCoupleFF,
      noActiveDarkMode: icCoupleFFDarkMode,
      activePng: 'icCoupleFFActive',
      noActivePng: 'icCoupleFF',
    },
    [SEX_TYPE.COUPLES_MM]: {
      active: icCoupleMMActive,
      noActive: icCoupleMM,
      noActiveDarkMode: icCoupleMMDarkMode,
      activePng: 'icCoupleMMActive',
      noActivePng: 'icCoupleMM',
    },
    [SEX_TYPE.TV_CD]: {
      active: icTVCDActive,
      noActive: icTVCD,
      noActiveDarkMode: icTVCDDarkMode,
      activePng: 'icTVCDActive',
      noActivePng: 'icTVCD',
    },
    [SEX_TYPE.TRANS_WOMAN]: {
      active: icTransWomanActive,
      noActive: icTransWoman,
      noActiveDarkMode: icTransWomanDarkMode,
      activePng: 'icTransWomanActive',
      noActivePng: 'icTransWoman',
    },
    [SEX_TYPE.TRANS_MAN]: {
      active: icTransManActive,
      noActive: icTransMan,
      noActiveDarkMode: icTransManDarkMode,
      activePng: 'icTransManActive',
      noActivePng: 'icTransMan',
    },
  },

  [CATEGORY_ID.MEETING_TYPE]: {
    [MEETING_TYPE.ANY_THING]: {
      active: icAnyThingActive,
      noActive: icAnyThing,
    },
    [MEETING_TYPE.CASUAL_ENCOUNTER]: {
      active: icCasualEncounterActive,
      noActive: icCasualEncounter,
    },
    [MEETING_TYPE.COCKTAIL_BAR]: {
      active: icCocktailBarActive,
      noActive: icCocktailBar,
    },
    [MEETING_TYPE.COFFEE]: { active: icCoffeeActive, noActive: icCoffee },
    [MEETING_TYPE.CONCERT]: {
      active: icConcertActive,
      noActive: icConcert,
    },
    [MEETING_TYPE.DINNER]: { active: icDinnerActive, noActive: icDinner },
    [MEETING_TYPE.FETISH_PARTY]: {
      active: icFetishPartyActive,
      noActive: icFetishParty,
    },
    [MEETING_TYPE.HANG_OUT]: {
      active: '',
      noActive: '',
    },
    [MEETING_TYPE.HOUSE_PARTY]: {
      active: icHousePartyActive,
      noActive: icHouseParty,
    },
    [MEETING_TYPE.MY_BEDROOM]: {
      active: icMyBedroomActive,
      noActive: icMyBedroom,
    },
    [MEETING_TYPE.MY_PLACE]: {
      active: icMyPlaceActive,
      noActive: icMyPlace,
    },
    [MEETING_TYPE.PUB_CRAWL]: {
      active: icPubCrawlActive,
      noActive: icPubCrawl,
    },
    [MEETING_TYPE.SPA_HOT_TUB]: {
      active: icSpaHotTubActive,
      noActive: icSpaHotTub,
    },
    [MEETING_TYPE.SPORTING_EVENT]: {
      active: icSportingEventActive,
      noActive: icSportingEvent,
    },
    [MEETING_TYPE.SWINGERS_PARTY]: {
      active: icSwingersPartyActive,
      noActive: icSwingersParty,
    },
  },
};

export const CATEGORY_LABEL_SHOW_TYPE = {
  TITLE_ON_VALUE: 1,
  TITLE_ON_COUNT: 2,
  LABEL_ON_LABEL: 3,
  VALUE_ON_VALUE: 4,
  PREFIX_WITH_VALUE_ON_PREFIX_WITH_VALUE: 5,
  TITLE: 6,
  PREFIX_ON_VALUE: 7,
  TITLE_ON_LABEL: 8,
};

export const ITEM_MORE_ID = 'MORE';

export const DEFAULT_AGE_RANGE = {
  MIN: 18,
  MAX_TEXT: '80+',
  MAX: 99,
};

export const MEMBER_SEARCH_SCREEN = {
  ENTITIES: {
    [CATEGORY_ID.MS_SHOW_ME_MEMBER_TYPE]: {
      label: 'showMe',
      url: 'membertypeplural',
    },
  },
  FILTERS_ENTITIES: {
    [CATEGORY_ID.LTM_LOOKING_FOR]: {
      label: 'PeopleLookingFor',
      url: 'membertypeplural',
    },
    [CATEGORY_ID.LTM_INTENTIONS]: { label: 'Intentions', url: 'intention' },
    [CATEGORY_ID.MARITAL_STATUS]: {
      label: 'RelationshipStatus',
      url: 'maritalstatus',
    },
    [CATEGORY_ID.TU2_BODY_TYPE]: { label: 'BodyType', url: 'bodytype' },
    [CATEGORY_ID.TU2_HEIGHT]: { label: 'Height', url: 'height' },
    [CATEGORY_ID.TU1_ETHNICITY]: { label: 'Ethnicity', url: 'race' },
    [CATEGORY_ID.WYI_SEXUAL]: { label: 'SexualOrientation', url: 'Sexual' },
    [CATEGORY_ID.SEXUAL_INTERESTS]: {
      label: 'SexualInterests',
      url: { single: 'SexualInterestSingle', couple: 'SexualInterestCouple' },
    },
    [CATEGORY_ID.WYI_FETISH]: {
      label: 'FestishInterests',
      url: 'FetishInterest',
    },
    [CATEGORY_ID.SAFE_SEX]: { label: 'SafeSex', url: 'SafeSex' },
    [CATEGORY_ID.ENDOWMENT]: { label: 'Endowment', url: 'EndowmentLength' },
    [CATEGORY_ID.PARTICIPATION_LEVEL]: {
      label: 'ParticipantionLevel',
      url: 'ParticipationLevel',
    },
    [CATEGORY_ID.CUP_SIZE]: { label: 'CupSize', url: 'cupsize' },
    [CATEGORY_ID.SMOKING]: { label: 'Smoking', url: 'smoking' },
    [CATEGORY_ID.PUBIC_HAIR]: { label: 'PubicHair', url: 'pubichair' },
  },
  FILTER_OTHER_ENTITIES: {
    userName: 'userName',
  },
  ACTION_TYPE: {
    LIKE: 'Like',
    UNLIKE: 'Unlike',
    IGNORE: 'Ignore',
    FAVORITE: 'Favourite',
    MESSENGER: 'Messenger',
  },
  INTEREST: {
    LIMIT_SHOW: 7,
  },
  KEY: {
    UP: 'ArrowUp',
    DOWN: 'ArrowDown',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    ENTER: 'Enter',
  },
  FILTER_AGE_RANGE: {
    MIN_AGE: 18,
    MAX_AGE: 99,
  },
  ORDER_BY_TYPE: {
    MEMBER_LEVEL: 1,
    MATCHING: 2,
    NEWEST: 3,
    ACTIVE: 4,
    TRAVELLING: 5,
    NEAR_BY: 6,
    ACTIVE_NOW: 7,
    SPOT_LIGHT: 8,
  },
  ORDER_BY_TYPE_VALUE: {
    MEMBER_LEVEL: 'MemberLevel',
    MATCHING: 'Relevance',
    NEWEST: 'NewMembers',
    ACTIVE: 'LastVisited',
    TRAVELLING: 'Traveling',
    NEAR_BY: 'NearBy',
    ACTIVE_NOW: 'ActiveNow',
    SPOT_LIGHT: 'SpotLight',
  },
};

export const CATEGORY_ID_MEMBER_PROFILE = {
  RELATIONSHIP: {
    name: 'relationshipStatus',
    label: 'MemberProfileScreen.RelationShip',
  },
  PERSONALITY: {
    name: 'personality',
    label: 'MemberProfileScreen.Personality',
  },
  STAR_SIGN: {
    name: 'starSign',
    label: 'MemberProfileScreen.StarSign',
  },
  DRINKING: {
    name: 'drinking',
    label: 'MemberProfileScreen.Drinking',
  },
  SMOKING: {
    name: 'smoking',
    label: 'MemberProfileScreen.Smoking',
  },
  LOOKS: {
    name: 'myLooks',
    label: 'MemberProfileScreen.Looks',
  },
  BODY_TYPE: {
    name: 'bodyType',
    label: 'MemberProfileScreen.BodyType',
  },
  HEIGHT: {
    name: 'height',
    label: 'MemberProfileScreen.Height',
  },
  RACE: {
    name: 'race',
    label: 'MemberProfileScreen.Race',
  },
  EYE_COLOUR: {
    name: 'eyeColour',
    label: 'MemberProfileScreen.EyeColour',
  },
  HAIR_COLOUR: {
    name: 'hairColour',
    label: 'MemberProfileScreen.HairColour',
  },
  HAIR_LENGTH: {
    name: 'hairLength',
    label: 'MemberProfileScreen.HairLength',
  },
  PARTICIPATION: {
    name: 'levelOfParticipation',
    label: 'MemberProfileScreen.Participation',
  },
  ORIENTATION: {
    name: 'sexualOrientation',
    label: 'MemberProfileScreen.Orientation',
  },
  SAFE_SEX: {
    name: 'safeSex',
    label: 'MemberProfileScreen.SafeSex',
  },
  PUBIC_HAIR: {
    name: 'pubicHair',
    label: 'MemberProfileScreen.PubicHair',
  },
  BODY_HAIR: {
    name: 'bodyHair',
    label: 'MemberProfileScreen.BodyHair',
  },
  ENDOWMENT: {
    name: 'endowmentLength',
    label: 'MemberProfileScreen.Endowment',
  },
  ENDOWMENT_THICKNESS: {
    name: 'endowmentThickness',
    label: 'MemberProfileScreen.EndowmentThickness',
  },
  CUP_SIZE: {
    name: 'cupSize',
    label: 'MemberProfileScreen.CupSize',
  },
  INTIMATE_PIERCINGS: {
    name: 'intimatePiercing',
    label: 'MemberProfileScreen.IntimatePiercing',
  },
  INTIMATE_PERSONALITY: {
    name: 'sexualPersonality',
    label: 'MemberProfileScreen.Personality',
  },
};

export const MEMBER_PROFILE_SCREEN = {
  PROFILES: {
    LIFE_STYLE: {
      categoryId: 'lifeStyle',
      categoryLabel: 'MemberProfileScreen.LifeStyle',
      items: [
        CATEGORY_ID_MEMBER_PROFILE.RELATIONSHIP,
        CATEGORY_ID_MEMBER_PROFILE.PERSONALITY,
        CATEGORY_ID_MEMBER_PROFILE.STAR_SIGN,
        CATEGORY_ID_MEMBER_PROFILE.DRINKING,
        CATEGORY_ID_MEMBER_PROFILE.SMOKING,
      ],
    },
    PHYSICAL: {
      categoryId: 'physical',
      categoryLabel: 'MemberProfileScreen.Physical',
      items: [
        CATEGORY_ID_MEMBER_PROFILE.LOOKS,
        CATEGORY_ID_MEMBER_PROFILE.BODY_TYPE,
        CATEGORY_ID_MEMBER_PROFILE.HEIGHT,
        CATEGORY_ID_MEMBER_PROFILE.RACE,
        CATEGORY_ID_MEMBER_PROFILE.EYE_COLOUR,
        CATEGORY_ID_MEMBER_PROFILE.HAIR_COLOUR,
        CATEGORY_ID_MEMBER_PROFILE.HAIR_LENGTH,
      ],
    },
    INTIMATE: {
      categoryId: 'intimate',
      categoryLabel: 'MemberProfileScreen.Intimate',
      items: [
        CATEGORY_ID_MEMBER_PROFILE.PARTICIPATION,
        CATEGORY_ID_MEMBER_PROFILE.ORIENTATION,
        CATEGORY_ID_MEMBER_PROFILE.SAFE_SEX,
        CATEGORY_ID_MEMBER_PROFILE.PUBIC_HAIR,
        CATEGORY_ID_MEMBER_PROFILE.BODY_HAIR,
        CATEGORY_ID_MEMBER_PROFILE.ENDOWMENT,
        CATEGORY_ID_MEMBER_PROFILE.ENDOWMENT_THICKNESS,
        CATEGORY_ID_MEMBER_PROFILE.CUP_SIZE,
        CATEGORY_ID_MEMBER_PROFILE.INTIMATE_PIERCINGS,
        CATEGORY_ID_MEMBER_PROFILE.INTIMATE_PERSONALITY,
      ],
    },
  },
};

export const MEMBER_PROSPEC_SCREEN = {
  CATEGORY_ID_USER_PROFILE_VIEWS_MEMBER_TYPE: 'userProfileViewsMemberType',
};

export const SERVER_ERROR = {
  REQUEST_TIME_OUT: 'Request timeout',
};

export const TYPE_ALERT_ID = {
  SUPPORT_TICKET_REPLY: 'SupportTicketReply',
  SUPPORT_TICKET_CREATED: 'SupportTicketCreated',
  PHOTO_REJECTED: 'PhotoRejected',
  PROFILE_REJECTED: 'ProfileRejected',
  PROFILE_SEEKING_REJECTED: 'ProfileSeekingRejected',
  USERNAME_REJECTED: 'UsernameRejected',
  COMMENT_REJECTED: 'CommentRejected',
  COMMENT_REPLY_REJECTED: 'CommentReplyRejected',
  FORUM_POST_REJECTED: 'ForumPostRejected',
  PROFILE_NOT_VIEWABLE: 'ProfileNotViewable',
  MESSAGE_NOT_ACCEPTING_NEW: 'MessageNotAcceptingNew',
  EMAIL_ADDRESS_MISSING: 'EmailAddressMissing',
  MESSAGE_ONLY_FAVOURITE: 'MessageOnlyFavourite',
  WELCOME_MESSAGE_TOUR: 'WelcomeMsgTour',
  SUBSCRIPTION_PAYMENT_SUCCESS: 'SubscriptionPaymentSuccess',
  SUBSCRIPTION_FAIL_SCREEN: 'SubscriptionPaymentFail',
  PROFILE_DESCRIPTION_APPROVED: 'ProfileDescriptionApproved',
  PROFILE_PHOTO_APPROVED: 'ProfilePhotoApproved',
  PROFILE_VERIFICATION_APPROVED: 'ProfileVerificationApproved',
  PROFILE_VERIFICATION_REJECTED: 'ProfileVerificationRejected',
  PROFILE_VERIFIED_REJECTED: 'ProfileVerifiedRejected',
  FORUM_TOPIC_REPLY: 'ForumTopicReply',
  STORY_COMMENTS: 'StoryComments',
  EVENT_COMMENTS: 'EventComments',
  PHOTO_MOVED_PRIVATE: 'PhotoMovedToPrivate',
  PROFILE_VERIFIED: 'ProfileVerified',
  MAIN_PHOTO_APPROVED: 'MainPhotoApproved',
  USERNAME_APPROVED: 'UsernameApproved',
  TRAVEL_REJECTED: 'TravelRejected',
  TRAVEL_APPROVED: 'TravelApproved',
  DATE_FINDER_REJECTED: 'DateFinderRejected',
  DATE_FINDER_APPROVED: 'DateFinderApproved',
  FORUM_TOPIC_APPROVED: 'ForumTopicApproved',
  FORUM_TOPIC_REJECTED: 'ForumTopicRejected',
  VALIDATION_REJECTED: 'ValidationRejected',
  EVENT_REJECTED: 'EventRejected',
  EVENT_APPROVED: 'EventApproved',
  MEMBER_TYPE_CHANGE_APPROVED: 'MemberTypeChangeApproved',
  MEMBER_TYPE_CHANGE_REJECTED: 'MemberTypeChangeRejected',
  VALIDATION_ACCEPTED: 'ValidationAccepted',
  FRIEND_REQUEST_ACCEPTED: 'FriendRequestAccepted',
  GROUP_JOIN_REQUEST_ACCEPTED: 'GroupJoinApproved',
  GROUP_JOIN_REQUEST_REJECTED: 'GroupJoinRejected',
  GROUP_ADD_REQUEST_ACCEPTED: 'GroupApproved',
  GROUP_ADD_REQUEST_REJECTED: 'GroupRejected',
  GROUP_ALBUM_APPROVED: 'GroupAlbumApproved',
  GROUP_ALBUM_REJECTED: 'GroupAlbumRejected',
  CLUB_POST_APPROVED: 'ClubPostApproved',
  CLUB_POST_REJECTED: 'ClubPostRejected',
  CLUB_EVENT_APPROVED: 'ClubEventApproved',
  CLUB_EVENT_REJECTED: 'ClubEventRejected',
  CLUB_PHOTO_APPROVED: 'ClubPhotoApproved',
  CLUB_PHOTO_REJECTED: 'ClubPhotoRejected',

  CLUB_POST_PHOTO_REJECTED: 'ClubPostPhotoRejected',
  CLUB_POST_VIDEO_REJECTED: 'ClubPostVideoRejected',
  CLUB_ALBUM_PHOTO_REJECTED: 'ClubAlbumPhotoRejected',
  CLUB_ALBUM_VIDEO_REJECTED: 'ClubAlbumVideoRejected',
  STREAM_STARTING: 'StreamStarting',
  STREAM_STARTED: 'StreamStarted',
  CLUB_NAME_REJECTED: 'ClubNameRejected',
  CLUB_DES_REJECTED: 'ClubDescriptionRejected',
  CLUB_RULE_REJECTED: 'ClubRulesRejected',
};
export const TYPE_ALERT_DESTINATION = {
  [TYPE_ALERT_ID.SUPPORT_TICKET_REPLY]: 'HelpSupport',
  [TYPE_ALERT_ID.SUPPORT_TICKET_CREATED]: 'HelpSupport',
  [TYPE_ALERT_ID.PHOTO_REJECTED]: 'MangePhoto',
  [TYPE_ALERT_ID.PROFILE_REJECTED]: 'ProfileRejected',
  [TYPE_ALERT_ID.PROFILE_SEEKING_REJECTED]: 'ProfileSeekingRejected',
  [TYPE_ALERT_ID.USERNAME_REJECTED]: 'UsernameRejected',
  [TYPE_ALERT_ID.COMMENT_REJECTED]: 'CommentRejected',
  [TYPE_ALERT_ID.COMMENT_REPLY_REJECTED]: 'CommentRejected',
  [TYPE_ALERT_ID.FORUM_POST_REJECTED]: 'ForumPostRejected',
  [TYPE_ALERT_ID.SUPPORT_TICKET_CREATED]: 'HelpSupport',
};

export const TYPE_OF_NOTIFICATION_ALERTS = {
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
  APPROVED: 'approved',
};

export type TypeOfNotificationAlertsType = (typeof TYPE_OF_NOTIFICATION_ALERTS)[keyof typeof TYPE_OF_NOTIFICATION_ALERTS];

export const TYPE_OF_NOTIFICATIONS_NOTIFICATIONS = {
  VALIDATION_ACCEPTED: 'ValidationAccepted',
  FRIEND_REQUEST_ACCEPTED: 'FriendRequestAccepted',
  SENT_A_FRIEND_REQUEST: 'SentAFriendRequest',
  SENT_A_FRIEND_REQUEST_FRIENDS: 'SentAFriendRequestFriends',
  SENT_A_FRIEND_REQUEST_DATE_FINDER_INTERESTS: 'SentAFriendRequestDateFinderInterests',
  WELCOME_MESSAGE_TOUR: 'WelcomeMsgTour',
  PHOTO_LIKE: 'PhotoLike',
  REQUEST_JOIN_GROUP: 'RequestJoinGroup',
  EVENT_INTEREST: 'EventInterest',
};

export const TYPE_OF_PROSPECT_CARD_ITEM = {
  PROSPECT_CARD_DELETE: 'ProspectCardDelete',
  FRIEND_CARD_ITEM: 'FriendCardItem',
  PROSPECT_CARD_LIKE: 'prospectCardLike',
  PROSPECT_CARD_FAV: 'prospectCardFav',
  PROSPECT_CARD_MATCH_LIKE: 'prospectCardMatchLike',
  PROSPECT_CARD_MATCH_FAV: 'prospectCardMatchFav',
};

export const MY_EVENT_STATUS = {
  PENDING: 'Pending',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
};

export const PROFILE_IMAGE_TYPES = {
  NONE: 'None',
  USER: 'User',
  RESTRICTED: 'Restricted',
  NO_PHOTO_IMAGE_IN_PRIVATE: 'NoPhotoImageInPrivate',
  NO_PHOTO: 'NoPhoto',
};

export const CATEGORY_QUICK_SELECT_DATE = {
  TONIGHT: 'tonight',
  TOMORROW: 'tomorrow',
};
export const STORY_CATEGORIES = [
  {
    id: 0,
    listId: 0,
    name: 'All stories',
  },
  {
    id: 1,
    listId: 45,
    name: 'RHP Encounters',
  },
  {
    id: 2,
    listId: 45,
    name: 'Swinging',
  },
  {
    id: 4,
    listId: 45,
    name: 'Group Sex',
  },
  {
    id: 8,
    listId: 45,
    name: 'Gay',
  },
  {
    id: 16,
    listId: 45,
    name: 'Kinky Fetishes',
  },
  {
    id: 32,
    listId: 45,
    name: 'Bi Sex',
  },
  {
    id: 64,
    listId: 45,
    name: 'Public Sex',
  },
  {
    id: 128,
    listId: 45,
    name: 'Misc.',
  },
  {
    id: 256,
    listId: 45,
    name: 'Lesbian',
  },
  {
    id: 512,
    listId: 45,
    name: 'Threesome',
  },
  {
    id: 1024,
    listId: 45,
    name: 'MMF',
  },
  {
    id: 2048,
    listId: 45,
    name: 'FFM',
  },
  {
    id: 4096,
    listId: 45,
    name: 'TV/TS/CD',
  },
  {
    id: 8192,
    listId: 45,
    name: 'Anal sex',
  },
  {
    id: 16384,
    listId: 45,
    name: 'BDSM',
  },
  {
    id: 32768,
    listId: 45,
    name: 'Cuckold',
  },
  {
    id: 65536,
    listId: 45,
    name: 'Hot wife',
  },
  {
    id: 131072,
    listId: 45,
    name: 'Hardcore',
  },
  {
    id: 262144,
    listId: 45,
    name: 'Cougar',
  },
  {
    id: 524288,
    listId: 45,
    name: 'Dogging',
  },
  {
    id: 1048576,
    listId: 45,
    name: 'Asian',
  },
  {
    id: 2097152,
    listId: 45,
    name: 'Big cock',
  },
  {
    id: 4194304,
    listId: 45,
    name: 'Open relationship / Affair',
  },
  {
    id: 8388608,
    listId: 45,
    name: 'Gangbang',
  },
  {
    id: 16777216,
    listId: 45,
    name: 'Sensual sex',
  },
  {
    id: 33554432,
    listId: 45,
    name: 'Bukake',
  },
  {
    id: 67108864,
    listId: 45,
    name: 'Blowjob',
  },
  {
    id: 134217728,
    listId: 45,
    name: 'Cum swallowing',
  },
  {
    id: 268435456,
    listId: 45,
    name: 'Cream Pie',
  },
  {
    id: 536870912,
    listId: 45,
    name: 'Rimming',
  },
  {
    id: 1073741824,
    listId: 45,
    name: 'Strap On & Pegging',
  },
];
export const ARTICLE_CATEGORIES = [
  {
    id: 0,
    listId: 0,
    name: 'All articles',
  },
  {
    id: 4248577,
    listId: 0,
    name: 'Sex',
  },
  {
    id: 2097282,
    listId: 0,
    name: 'Entertainment',
  },
  {
    id: 8192,
    listId: 0,
    name: 'Swingers',
  },
  {
    id: 16779528,
    listId: 0,
    name: 'Dating',
  },
  {
    id: 36,
    listId: 0,
    name: 'Lifestyle',
  },
  {
    id: 9109584,
    listId: 0,
    name: 'Products & reviews',
  },
  {
    id: 1048576,
    listId: 0,
    name: 'Date Doctors',
  },
];

export const ON_THE_GROUND_LOOKUP_TYPE = {
  ALL: 'All',
  GALLERY: 'Gallery',
  VIDEO: 'Video',
};

export const ASK_SAMANTHA_CATEGORIES = [
  { id: 0, name: 'All categories', listId: 0 },
  { id: 1, name: "Men's Sexual Issues", listId: 0 },
  { id: 2, name: "Women's Sexual Issues", listId: 0 },
  { id: 4, name: 'Dating/Relationship', listId: 0 },
  { id: 8, name: 'Profile Clinic', listId: 0 },
  { id: 16, name: "Couple's Issues", listId: 0 },
  { id: 32, name: 'Threesomes/Moresomes ', listId: 0 },
  { id: 64, name: 'Ask Bessie & Geoff', listId: 0 },
];
